import React, { Component } from 'react';
import './About.css';
import Dropdown from '../Dropdown';
import {Link} from 'react-router-dom';
import RightMenu from "../RightMenu";
export default class About extends Component{

	constructor(props){
		super(props);
		//console.log(props);
		this.state = {
			data: props.data.article,
			rightMenu: props.data.right_menu||[],
			// prevDropdown: props.data.prev_dropdown,
			// rightMenu: [],
			config: props.hasOwnProperty('config') ? props.config : [],
			prevDropdown: props.data.hasOwnProperty('prev_dropdown') ? props.data.prev_dropdown : [],
		}
	}

	render(){
		var mobile_lead = this.state.data.lead ? <div className="mobile_lead"><div className="mobile_lead_inner" dangerouslySetInnerHTML={{ __html: this.state.data.lead }}></div></div> : null;
		var about_text_style = this.state.data.lead ? {paddingTop: 15} : null;
		//console.log('About',this.state);

		return (
			<div className="About">
				<div className="row">
					<div className="about_title artists-pageTitle col-sm-9" dangerouslySetInnerHTML={{ __html: this.state.data.title }}></div>
					<div
						className={`
							? "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex"
							: "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3"
						`}
						>
							{this.state.prevDropdown.length ||
								Object.keys(this.state.prevDropdown).length ? (
									<Dropdown
										giveMeClassName={`${
											this.state.prevDropdown.dates.length > 5
											? "festiwal--dropdown"
											: "normal"
										}`}
										data={this.state.prevDropdown}
									/>
								) : null}
							</div>
				</div>
				<div className="about-topbanner-box">

							<div className="about_img_block" style={{backgroundImage: "url(" + this.state.data.cover_photo + ")"}}>
								<div className="about-colorbox" style={{backgroundColor: '#'+this.state.config.gbcolor}}></div>
							</div>
				</div>

				<div className="about-content left col-xs-12 col-sm-10 col-md-9 col-lg-9">
					<div className="mobileMenu">
						<ul>
							{this.state.rightMenu.map(function(object, i){
								return (<li className="about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>


					{mobile_lead}
					<div className="about_text" style={about_text_style} dangerouslySetInnerHTML={{ __html: this.state.data.text }}></div>

				</div>
				<div className="right col-xs-2 col-sm-2 col-md-3 col-lg-3">

				{/* {	 this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}

				{/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}
					<div className="disctopMenuright">
						<ul>
							{this.state.rightMenu.map(function(object, i){

							return (<li className="about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>


				</div>
			</div>
		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Elements/About/About.js